<template>
        <el-popover placement="left"
                width="500"
                v-model="visible">
        <el-form inline class="demo-form-inline">

            <div class="d-flex justify-content-end px-3 pt-3">
                <company-selector
                    v-model="selected_reseller_id"
                    class="w-full"
                    placeholder="Select a reseller"
                    clearable
                    filterable
                    :is_reseller="true"
                    @change="resellerChange">
                </company-selector>
            </div>
            <div class="d-flex justify-content-center px-3 pt-3">
                <el-button class="w-full" type="primary" @click="onSubmit">Save</el-button>
            </div>
        </el-form>
        <button slot="reference"
                class="btn btn-sm btn-block indigo mt-2"
                :disabled="loading">
            Add/Remove Reseller
        </button>
    </el-popover>
</template>

<script>
import CompanySelector from "../../components/company-selector"

export default {

    components: {CompanySelector},

    props: {
        company: {
            required: true,
            type: Object
        }
    },

    data() {
        return {
            resellers: [],
            selected_reseller_id: null,
            loading: false,
            visible: false,
        }
    },

    mounted() {
        this.getResellers()
        this.selected_reseller_id = this.company.reseller_id
    },

    methods: {
        resellerChange(reseller_id) {
            this.selected_reseller_id = reseller_id
        },

        onSubmit() {
            axios.patch(`/api/admin/company/${this.company.id}/reseller`, {
                reseller_id: this.selected_reseller_id
            }).then(res => {
                this.$emit('reseller-updated', res)
                this.$notify({
                    title: "Add/Remove Reseller",
                    message: 'Company\'s reseller has been updated successfully.',
                    type: "success",
                    showClose: true,
                })
                this.toggleVisibility()
            }).catch(err => {
                console.log(err)
                this.$root.handleErrors(err.response)
            })
        },

        getResellers() {
            this.loading = true
            axios.get('/api/admin/resellers').then(res => {
                this.resellers = res.data
                this.loading = false
            }).catch(err => {
                console.log(err)
                this.loading = false
                this.$root.handleErrors(err.response)
            })
        },

        toggleVisibility() {
            this.visible = !this.visible
        }
    },
}
</script>
